import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./features/homepage/HomePage";
import Impressum from "./features/impressum/Impressum";
import Datenschutz from "./features/datenschutz/Datenschutz";
import Kontakt from "./features/kontakt/Kontakt";
import Training from "./features/training/Training";
import Tauchen from "./features/tauchen/Tauchen";
import Mitgliedschaft from "./features/mitgliedschaft/Mitgliedschaft";
import Verein from "./features/verein/Verein";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import "./App.css";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="page-container">
        <Header />

        <main className="content-wrap">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/training" element={<Training />} />
            <Route path="/tauchen" element={<Tauchen />} />
            <Route path="/mitgliedschaft" element={<Mitgliedschaft />} />
            <Route path="/verein" element={<Verein />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
